<!-- CRUD operations to device location (device_address)
    Creates a new location if not exists
    Updates a location if exists
-->
<template>
    <div>
        <div class="text-right mr-3 mb-1">
            <b-link v-if="device_address"
                    @click="display_address_detail = !display_address_detail"
                    id="location-crud-link"> {{ display_address_detail ? 
                                                    (device_address.id ? 'Update Location' : 'Set Location') 
                                                    : 'Cancel' }} </b-link>
        </div>
        <b-table v-if="display_address_detail"
                 :id="`device-address-table`"
                 :items="device_address ? [device_address] : []"
                 :fields="fields.address"
                 stacked
                 show-empty />
        <div v-else style="width:90%; margin:auto" class="mb-5">
            <k-form :form="address_form"
                    table="address"
                    method="update"
                    @submit="save_address" />
        </div>
    </div>
</template>

<script>
    import { create_device_address, update_device_address } from '../networking/devices'
    import { stateOptions } from '../config/address'
    import { KForm } from 'ui-common'

    const address_fields = [
        { key: 'line_1', label: 'Address Line 1' },
        { key: 'line_2', label: 'Address Line 2' },
        { key: 'city' },
        {
            key: 'state', formatter: state => stateOptions.find(({ value }) => value == state)
                ? stateOptions.find(({ value }) => value == state).text : state
        },
        { key: 'zip' }
    ]
    const default_form = { required: true, type: 'text', model: null, placeholder: '' }
    const address_form = [
        { ...default_form, label: `Address Line 1`, id: 'line_1' },
        { ...default_form, label: `Address Line 2`, id: 'line_2', required: false },
        { ...default_form, label: `City`, id: 'city' },
        { ...default_form, label: `State`, id: 'state', input: 'search', options: stateOptions },
        { ...default_form, label: `Zip Code`, id: 'zip' }
    ]

    export default {
        name: 'k-device-location-crud',
        components: { KForm },
        props: {
            device_address: { required: true },
            device_id: { required: true }
        },

        data(){
            return {
                display_address_detail: true,
                fields: {
                    address: address_fields
                },
                address_form: address_form
            }
        },

        mounted() {},

        methods: {

            async save_address(form) {
                const body = form.reduce((d, { id, model }) => ({ ...d, [id]: model }), {})
                body["device_id"] = this.device_id
                let generator = null;

                if (this.device_address.id) {
                    body["id"] = this.device_address.id
                    generator = update_device_address(body)
                } else {
                    generator = create_device_address(body)
                }
                
                const { value: { alert, data = {} } } = await generator.next()
                this.$emit('showAlert', alert.message, alert.variant, alert.variant === 'success' ? 1800 : null)

                if (alert.variant === 'success') {
                    this.display_address_detail = !this.display_address_detail
                    this.$emit("update_location", data);
                }
            },

        },
        watch: {
            device_address: function (address) {
              this.address_form = this.address_form.map(
                    field => ({ ...field, model: address ? address[field.id] : null }) // Populates form values from address detail data.
                ).map(field => field.id === 'state'
                    ? { ...field, input: 'select', options: stateOptions }
                    : field
                )
            }
        }

    }

</script>
